<template>
  <div>
    <FilterPanel :sports="sports" :centers="centers" @filter="applyFilters" />
    <v-row v-if="start">
      <v-col cols="12" md="12">
        <ReservationAmountByMonth :filters="appliedFilters"/>
      </v-col>
      <v-col cols="12" md="12">
        <ReservationByDate :filters="appliedFilters"/>
      </v-col>
      <v-col cols="12" md="6">
        <ChartReservationBySport :filters="appliedFilters" :sports="sports" />
      </v-col>

      <v-col cols="12" md="3">
        <TopCenters :filters="appliedFilters" :centers="centers" />
      </v-col>

      <v-col cols="12" md="3">
        <TopUsers :filters="appliedFilters" :sports="sports" />
      </v-col>

      <v-col cols="12" md="12">
        <ReservationBySlotAndWeekday :filters="appliedFilters"/>
      </v-col>

      <v-col cols="12" md="12">
        <ReservationByGeo :filters="appliedFilters"/>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import FilterPanel from "@/components/analytics/FilterPanel.vue";
import ChartReservationBySport from "@/components/analytics/ChartReservationBySport.vue";
import TopCenters from "@/components/analytics/TopCenters.vue";
import TopUsers from "@/components/analytics/TopUsers.vue";
import ReservationBySlotAndWeekday from "@/components/analytics/ReservationBySlotAndWeekday.vue";
import ReservationByGeo from "@/components/analytics/ReservationByGeo.vue";
import 'leaflet/dist/leaflet.css';
import ReservationByDate from "@/components/analytics/ReservationByDate.vue";
import moment from 'moment';
import ReservationAmountByMonth from "@/components/analytics/ReservationAmountByMonth.vue";

export default {
  name: 'Analytics',
  components: {
    ReservationAmountByMonth,
    ReservationByDate,
    ReservationByGeo,
    ReservationBySlotAndWeekday,
    TopUsers,
    TopCenters,
    FilterPanel,
    ChartReservationBySport
  },
  data() {
    return {
      appliedFilters: {},
      sports: [],
      centers: [],
      start: false
    };
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
      'setMiniSidebar': 'settings/setMiniSidebar',
    }),
    applyFilters(filters) {
      this.setLoading(true);
      this.appliedFilters = { ...filters };
      this.setLoading(false);
    },
    async getSports() {
      this.sports = await this.$store.dispatch('sports/index');
    },
    async getCenters() {
      this.centers = await this.$store.dispatch('centers/getList');
    }
  },
  async created() {
    if (!this.getUser.super_admin) this.$router.push('/');
    await this.setMiniSidebar(true)
    this.setLoading(true);
    await this.getSports();
    await this.getCenters();
    const today = moment().startOf('day');
    this.appliedFilters.from = today.clone().subtract(30, 'days').valueOf();
    this.appliedFilters.to = today.valueOf();
    this.start = true;
    this.setLoading(false);
  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser',
    }),
  },
}
</script>
